<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：状态列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleStateSelect('')"
              :class="{ 'selected': downShopHouseManageInfo.conditions.state === '' }">
              全部
            </li>
            <li v-for="(item, index) in downShopHouseManageInfo.states" :key="index"
              @click="handleStateSelect(item.statusCd)"
              :class="{ 'selected': downShopHouseManageInfo.conditions.state === item.statusCd }">
              {{ item.name }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <div class="search-form">
            <el-form :inline="true" :model="downShopHouseManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input
                  v-model="downShopHouseManageInfo.conditions.personName"
                  placeholder="请输入申请人"
                  clearable
                />
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="downShopHouseManageInfo.conditions.orderId"
                  placeholder="请输入单号"
                  clearable
                />
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="downShopHouseManageInfo.conditions.queryStartTime"
                  type="date"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="downShopHouseManageInfo.conditions.queryEndTime"
                  type="date"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="_queryShopHouseMethod">
                  <i class="el-icon-search"></i>查询
                </el-button>
                <el-button @click="_resetShopHouseMethod">
                  <i class="el-icon-refresh"></i>重置
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 退货单表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <span>退货单</span>
            <el-button
              type="primary"
              size="small"
              style="float:right"
              @click="_openAddShopHouseModal"
            >
              <i class="el-icon-plus"></i>申请退货
            </el-button>
          </div>
          <el-table
            :data="downShopHouseManageInfo.inoutOrders"
            border
            style="width:100%"
          >
            <el-table-column prop="orderId" label="单号" align="center" />
            <el-table-column prop="stateName" label="状态" align="center" />
            <el-table-column prop="personName" label="申请人" align="center" />
            <el-table-column prop="createTime" label="申请时间" align="center" />
            <el-table-column prop="remark" label="备注" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.state=='1001'"
                  type="text"
                  size="small"
                  @click="_openAuditModal(scope.row)"
                >
                  审核
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="_toDetail(scope.row)"
                >
                  详情
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="_deleteUpShopHouse(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="downShopHouseManageInfo.conditions.page"
            :page-size="downShopHouseManageInfo.conditions.row"
            layout="total, prev, pager, next, jumper"
            :total="downShopHouseManageInfo.total"
          />
        </el-card>
      </el-col>
    </el-row>

    <delete-inout-order ref="deleteInoutOrder" @refresh="_refreshList" />
    <down-shop-house-audit ref="downShopHouseAudit" @refresh="_refreshList" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryInoutOrder } from '@/api/goods/downShopHouseApi'
import DeleteInoutOrder from '@/components/goods/deleteInoutOrder/deleteInoutOrder'
import DownShopHouseAudit from '@/components/goods/downShopHouseAudit/downShopHouseAudit'

export default {
  components: {
    DeleteInoutOrder,
    DownShopHouseAudit
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      downShopHouseManageInfo: {
        inoutOrders: [],
        total: 0,
        records: 1,
        states: [],
        conditions: {
          personName: '',
          orderId: '',
          orderType: '20000',
          state: '',
          shopId: '',
          queryStartTime: '',
          queryEndTime: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      let shopId = getShopId()
      this.downShopHouseManageInfo.conditions.shopId = shopId
      await this._listInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      await this._getDictData()
    },
    async _getDictData() {
      try {
        const {data} = await getDict('inout_order', 'state')
        this.downShopHouseManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listInoutOrder(page, rows) {
      this.downShopHouseManageInfo.conditions.page = page
      this.downShopHouseManageInfo.conditions.row = rows
      try {
        const params = {
          ...this.downShopHouseManageInfo.conditions,
          orderId: (this.downShopHouseManageInfo.conditions.orderId || '').trim(),
          personName: (this.downShopHouseManageInfo.conditions.personName || '').trim()
        }
        const res = await queryInoutOrder(params)
        this.downShopHouseManageInfo.inoutOrders = res.data || []
        this.downShopHouseManageInfo.total = res.total || 0
        this.downShopHouseManageInfo.records = res.records || 0
      } catch (error) {
        console.error('获取退货单列表失败:', error)
        this.$message.error('获取退货单列表失败')
      }
    },
    _openAddShopHouseModal() {
      this.$router.push('/pages/goods/downShopHouseOutManage')
    },
    _queryShopHouseMethod() {
      this._listInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetShopHouseMethod() {
      this.downShopHouseManageInfo.conditions.personName = ''
      this.downShopHouseManageInfo.conditions.orderId = ''
      this.downShopHouseManageInfo.conditions.queryStartTime = ''
      this.downShopHouseManageInfo.conditions.queryEndTime = ''
      this._listInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handleStateSelect(state) {
      this.downShopHouseManageInfo.conditions.state = state
      this.downShopHouseManageInfo.conditions.page = 1
      this._listInoutOrder(1, this.DEFAULT_ROWS)
    },
    _deleteUpShopHouse(row) {
      this.$refs.deleteInoutOrder.open(row)
    },
    _openAuditModal(row) {
      this.$refs.downShopHouseAudit.open(row)
    },
    _refreshList() {
      this._listInoutOrder(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _toDetail(row) {
      this.$router.push(`/pages/goods/upShopHouseDetail?orderId=${row.orderId}`)
    },
    handleCurrentChange(val) {
      this._listInoutOrder(val, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.margin-top-sm {
  margin-top: 20px;
}

.search-form {
  padding: 18px 0 0;
}
</style>